import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
      "custom-class": "App-User-Profile-Modal",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Startup Experience",
      center: "",
      "close-on-click-modal": _ctx.showClose,
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: _ctx.disabledSave || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Save Experience ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_image, {
                style: `width: 150px;`,
                src: _ctx.img
              }, null, 8, ["src"]),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, [
                _createTextVNode(" Tell us about your experience "),
                _createElementVNode("br"),
                _createTextVNode(" creating value for others. ")
              ], -1))
            ])
          ]),
          _createVNode(_component_el_form, {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            class: "App-Styled-Form",
            "label-position": 'top',
            "label-width": "100px",
            model: _ctx.form,
            style: {"margin-top":"12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "businessModel",
                label: "Which business models are you good at?"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.startupExperience.models,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.startupExperience.models) = $event)),
                    placeholder: "Business Model: ex: Edtech",
                    "w-100": "",
                    size: "large",
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessModels, (ind) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          value: ind,
                          label: ind,
                          key: `${ind}-ind`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_space, null, {
                              default: _withCtx(() => [
                                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "App-Loc-Icon el-icon-business" }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(ind), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "stage",
                label: "Which startup stages are you good at?"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    size: "large",
                    modelValue: _ctx.form.startupExperience.stages,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.startupExperience.stages) = $event)),
                    placeholder: "Startup Stage: ex: MVP",
                    "w-100": "",
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages, (ind) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          value: ind,
                          label: ind,
                          key: `${ind}-ind`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_space, null, {
                              default: _withCtx(() => [
                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "App-Loc-Icon el-icon-business" }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(ind), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "onOpen", "close-on-click-modal", "before-close"])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}